// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1bIDU","content":"LoadingAlert_content__-o8ys"};